/* eslint-disable consistent-return */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withContent from '../../../containers/withContent';
import pageContent from '../../../payees/components/AddNewPayeeLandingPage/index.content';
import { withScrollTop } from '../../../containers/withScrollTop';
import {
	getEditPayeeDetails,
	getLinkAccountDetails,
	getAddPayeeFormDetails,
	getIsPayeeDeleted,
	isValidChapsCharsFormat,
	getEditChapsButtonStatus,
} from '../../../payees/states/addPayee/selectors';
import { addPayeeFormPropTypes, linkAccountDetailsPropTypes } from '../../../payees/states/addPayee/propTypes';
import {
	setAddPayeeForm,
	submitAddPayeeRequest,
	updateBeneficiaryEvent,
	beneficiaryEventsFailure,
	submitInternationalAddPayeeRequest,
	setGenericError,
	resetAddPayeeForm,
	updateAddPayeeForm,
} from '../../../payees/states/addPayee/actions';
import {
	showAllErrors,
	initValidationForEditPayeeChaps,
	deleteValidationField,
	removeKey,
} from '../../../states/validation/actions';
import { isSpecificFormValid } from '../../../states/validation/selectors';
import { getBankId, getClientContext, getToken } from '../../../states/session/selectors';
import { getSourceAccountId, isInternationalPayee, getScheduledPaymentsModalContentKey } from '../../states/selectors';
import { setEditPayeeFlag, submitDeletePayeeRequest, SUBMIT_DELETE_PAYEE_SUCCESS } from '../../states/action';
import { getApiBaseUrlPaas } from '../../../states/envConfig/selectors';
import { addPayeeFormFormatter } from '../../../utils/payeeUtils';
import ChapsDetails from '../../../payees/components/AddPayeeForm/ChapsDetails';
import { getValidationRowState } from '../../../states/validation/selectors';
import { updateValidation, hideErrorMsg } from '../../../states/validation/actions';
import { ServicingSection } from 'web-ui-components/lib/global/layout';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import { goBackPage, pages } from '../../../states/page/actions';
import { hasApiCallInProgress } from '../../../states/api/selectors';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { ButtonGroup } from 'web-ui-components/lib/molecules/buttons';
import { getSelectedPayeeDetails } from '../../../managePayee/states/selectors';
import { getUserId } from '../../../states/user/selectors';
import { getCustomerType } from '../../../effectiveWarning/state/selectors';
import { PageHeading } from 'web-ui-components/lib/typography/headings';

const mapState = (state, props) => ({
	validations: getValidationRowState(state, props.id),
	payeeDetails: getEditPayeeDetails(state),
	formValid: isSpecificFormValid(state, props.id),
	sourceAccountId: getSourceAccountId(state),
	addPayeeForm: getAddPayeeFormDetails(state),
	linkAccountDetails: getLinkAccountDetails(state, props.accountsForAddPayee),
	bankId: getBankId(state),
	apiBaseUrlPaas: getApiBaseUrlPaas(state),
	clientContext: getClientContext(state),
	isInternationalPayee: isInternationalPayee(state),
	token: getToken(state),
	isPayeeDeleted: getIsPayeeDeleted(state),
	scheduledPaymentsModalContentKey: getScheduledPaymentsModalContentKey(state),
	isValidChapsCharsFormat: isValidChapsCharsFormat(state),
	hasApiCallInProgress: hasApiCallInProgress(state),
	selectedPayee: getSelectedPayeeDetails(state),
	customerId: getUserId(state),
	customerType: getCustomerType(state),
	isEditChapsButtonDisabled: getEditChapsButtonStatus(state, props),
});

const mapDispatch = (dispatch, props) => ({
	updateValidation: (key, isValid, isFocusOn, isBackEndError, showValidation) =>
		dispatch(updateValidation({ id: props.id, key, isValid, isFocusOn, isBackEndError, showValidation })),
	hideErrorMsg: (key) => dispatch(hideErrorMsg({ id: props.id, key })),
	setAddPayeeForm: (payeeDetails) => dispatch(setAddPayeeForm(payeeDetails)),
	showAllErrors: () => dispatch(showAllErrors(props.id)),
	submitDeletePayeeRequest: (sourceAccountId) => dispatch(submitDeletePayeeRequest(sourceAccountId)),
	deleteValidationField: (id, fieldId) => dispatch(deleteValidationField(id, fieldId)),
	initValidationForEditPayeeChaps: (payeeDetails) => dispatch(initValidationForEditPayeeChaps(props.id, payeeDetails)),
	submitAddPayeeRequest: ({ payeeDetails, account, copDetails }) =>
		dispatch(submitAddPayeeRequest({ id: props.id, payeeDetails, account, copDetails })),
	setEditPayeeFlag: () => dispatch(setEditPayeeFlag()),
	beneficiaryEventsFailure: () => dispatch(beneficiaryEventsFailure()),
	submitInternationalAddPayeeRequest: (addPayeeForm, linkAccountDetails) =>
		dispatch(submitInternationalAddPayeeRequest(props.id, addPayeeForm, linkAccountDetails)),
	removeKey: (idObj) => dispatch(removeKey(idObj)),
	setGenericError: (errorCode) => dispatch(setGenericError(errorCode)),
	resetAddPayeeForm: () => dispatch(resetAddPayeeForm(props.id)),
	updateAddPayeeForm: (value) => dispatch(updateAddPayeeForm(value)),
	goBackPage: () => dispatch(goBackPage()),
});

export class EditChaps extends Component {
	constructor(props) {
		super(props);
		this.handleUpdateChapsSubmit = this.handleUpdateChapsSubmit.bind(this);
		this.handleSubmission = this.handleSubmission.bind(this);
		this.updatePayeeChapsForm = this.updatePayeeChapsForm.bind(this);
	}

	componentWillMount() {
		const { setAddPayeeForm, payeeDetails, initValidationForEditPayeeChaps } = this.props;
		initValidationForEditPayeeChaps(payeeDetails);
		setAddPayeeForm(payeeDetails);
	}

	componentWillUnmount() {
		const { removeKey, id } = this.props;
		removeKey({ id });
	}

	handleUpdateChapsSubmit() {
		const { showAllErrors, formValid, setEditPayeeFlag, isValidChapsCharsFormat, setGenericError } = this.props;
		setEditPayeeFlag();
		if (!formValid) return showAllErrors();
		if (!isValidChapsCharsFormat) {
			window.scrollTo(0, 0);
			return setGenericError('incorrectDetailsForChaps');
		}

		this.handleSubmission();
	}

	handleSubmission() {
		const {
			bankId,
			submitAddPayeeRequest,
			addPayeeForm,
			linkAccountDetails,
			apiBaseUrlPaas,
			clientContext,
			beneficiaryEventsFailure,
			token,
			resetAddPayeeForm,
			customerId,
			customerType,
			selectedPayee,
			isPayeeDeleted,
			sourceAccountId,
			submitDeletePayeeRequest,
		} = this.props;

		const { confirmation_of_payee, cop_account_name, cop_account_type } = selectedPayee;

		const copDetails = {
			accountName: addPayeeForm.name,
			accountNumber: addPayeeForm.accountNumber,
			sortCode: addPayeeForm.sortCode,
			accountType: addPayeeForm.copType,
			reference: addPayeeForm.reference,
			customerId: customerId,
			customerType: customerType,
			page: pages.COP.MakeMatch,
			payeeName: cop_account_name,
			payeeType: cop_account_type,
			result: confirmation_of_payee,
		};

		if (!isPayeeDeleted) {
			submitDeletePayeeRequest(sourceAccountId).then((response) => {
				if (response.type === SUBMIT_DELETE_PAYEE_SUCCESS) {
					submitAddPayeeRequest({ payeeDetails: addPayeeForm, account: linkAccountDetails, copDetails });
				}
			});
		} else {
			submitAddPayeeRequest({ payeeDetails: addPayeeForm, account: linkAccountDetails, copDetails });
		}

		updateBeneficiaryEvent({
			bankId,
			apiBaseUrlPaas,
			addPayeeForm,
			clientContext,
			beneficiaryEventsFailure,
			token,
		});
		resetAddPayeeForm();
	}
	updatePayeeChapsForm(event) {
		const { updateAddPayeeForm, addPayeeForm } = this.props;
		const {
			target: { id, value },
		} = event;
		const formattedValue = addPayeeFormFormatter[id] ? addPayeeFormFormatter[id](event, addPayeeForm) : value;
		if (addPayeeForm[id] !== formattedValue) {
			updateAddPayeeForm({ [id]: formattedValue });
		}
	}

	render() {
		const {
			addPayeeForm,
			content: { cancelButtonLabel, editChapsHeader, saveButtonLabel },
			content,
			validations,
			updateValidation,
			isEditChapsButtonDisabled,
			goBackPage,
			hasApiCallInProgress,
		} = this.props;

		const validationProps = {
			validations,
			updateValidation,
			hideErrorMsg,
			onChange: this.updatePayeeChapsForm,
			onFocusCheck: false,
		};
		return (
			<ServicingSection>
				<BackButton onClick={goBackPage} disabled={hasApiCallInProgress} />
				<PageHeading data-test-id="edit-chaps">{editChapsHeader}</PageHeading>
				<ChapsDetails
					addPayeeForm={addPayeeForm}
					updateAddPayeeForm={this.updatePayeeChapsForm}
					content={content}
					validationProps={validationProps}
				/>
				<ButtonGroup>
					<Button display="secondary" width="flush" onClick={goBackPage} disabled={hasApiCallInProgress}>
						{cancelButtonLabel}
					</Button>
					<Button
						display="primary"
						width="flush"
						onClick={this.handleUpdateChapsSubmit}
						disabled={isEditChapsButtonDisabled}
						isLoading={hasApiCallInProgress}
					>
						{saveButtonLabel}
					</Button>
				</ButtonGroup>
			</ServicingSection>
		);
	}
}

EditChaps.propTypes = {
	payeeDetails: PropTypes.shape(addPayeeFormPropTypes).isRequired,
	setAddPayeeForm: PropTypes.func.isRequired,
	showAllErrors: PropTypes.func.isRequired,
	initValidationForEditPayee: PropTypes.func.isRequired,
	formValid: PropTypes.bool.isRequired,
	bankId: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	sourceAccountId: PropTypes.string.isRequired,
	submitDeletePayeeRequest: PropTypes.func.isRequired,
	submitAddPayeeRequest: PropTypes.func.isRequired,
	addPayeeForm: PropTypes.shape(addPayeeFormPropTypes).isRequired,
	linkAccountDetails: PropTypes.shape(linkAccountDetailsPropTypes).isRequired,
	setEditPayeeFlag: PropTypes.func.isRequired,
	beneficiaryEventsFailure: PropTypes.func.isRequired,
	submitInternationalAddPayeeRequest: PropTypes.func.isRequired,
	apiBaseUrlPaas: PropTypes.string.isRequired,
	clientContext: PropTypes.string.isRequired,
	isInternationalPayee: PropTypes.bool.isRequired,
	token: PropTypes.string.isRequired,
	isPayeeDeleted: PropTypes.bool.isRequired,
	removeKey: PropTypes.func.isRequired,
	scheduledPaymentsModalContentKey: PropTypes.string.isRequired,
	isValidChapsCharsFormat: PropTypes.bool.isRequired,
	setGenericError: PropTypes.func.isRequired,
};

export default compose(connect(mapState, mapDispatch), withScrollTop, withContent({ content: pageContent }))(EditChaps);
